import OrTemperatureSensor from '@c/sensorConfigs/OrTemperatureSensor.vue';
import OrAccelerometerSensor from '@c/sensorConfigs/OrAccelerometerSensor.vue';
import OrTahoSensor from '@c/sensorConfigs/OrTahoSensor.vue';
import OrEnergySensor from '@c/sensorConfigs/OrEnergySensor.vue';
import {
  MachineWorkingStatusScheme,
  MachineWorkingErrorScheme,
  NodeStatusScheme,
} from './interfaces';
import {ConfigType} from '@/enums/configs';

/*
Словарь для получения начального отображаемого значения датчика.
В идеале для каждого датчика должна быть возможность задавать свое значение.
Но пока нет базы данных сделан этот словарь.
Словарь сделан по типу ПМ, т. к. идентификатор может поменяться.
*/

export const valueInfoAliasConf: Map<ConfigType, string> = new Map<ConfigType, string>([
  [ConfigType.OrTahoModule, 'mean'],
  [ConfigType.OrCrmModule, 'mean'],
  [ConfigType.OrTemperatureSourceModule, 'mean'],
  [ConfigType.OrEnergyModule, 'stdDev'],
  [ConfigType.OrAccelerometerModule, 'stdDev'],
]);

/*
  Словарь для биндинга компоненты датчика по типу датчика
*/
export const sensorTypeComponentMap: Map<ConfigType, any> = new Map<ConfigType, any>([
  [ConfigType.OrTahoModule, OrTahoSensor],
  [ConfigType.OrCrmModule, OrTahoSensor],
  [ConfigType.OrTemperatureSourceModule, OrTemperatureSensor],
  [ConfigType.OrEnergyModule, OrEnergySensor],
  [ConfigType.OrAccelerometerModule, OrAccelerometerSensor],
]);

/*
  Цветовая схема для диаграммы статусов виджета Структура предприятия
*/
export const fsStatusDiagramColorScheme: {
  week: {
    status: MachineWorkingStatusScheme;
    error: string;
  };
  day: {
    status: MachineWorkingStatusScheme;
    error: string;
  };
} = {
  week: {
    status: {
      off: '#F5F5F5',
      idle: '#0075eb',
      work: '#64DD17',
      incorrect: '#DDA0DD',
    },
    error: '#D50000',
  },
  day: {
    status: {
      off: '#F5F5F5',
      idle: '#00b0eb',
      work: '#AEEA00',
      incorrect: '#DDA0DD',
    },
    error: 'red',
  },
};

/*
  Цветовая схема для диаграммы ошибок
*/
export const errorDiagramColorScheme: {error: string; noerror: string} = {
  error: '#E53935',
  noerror: '#FFF9C4',
};

/*
  Цветовая схема для диаграммы статусов
*/
export const statusDiagramColorScheme: MachineWorkingStatusScheme = {
  off: '#F5F5F5',
  idle: '#0075eb',
  work: '#64DD17',
  incorrect: '#DDA0DD',
};

/*
  Наименования для ошибок работы станка
*/
export const machineWorkingErrorTitles: MachineWorkingErrorScheme = {
  error: 'Ошибки',
  noerror: 'Нет ошибок',
};

/*
  Наименования статусов работы станка
*/
export const machineWorkingStatusTitles: MachineWorkingStatusScheme = {
  off: 'Выключено',
  idle: 'Холостой режим',
  work: 'Рабочий режим',
  incorrect: 'Системная ошибка',
};

/*
  Цветовая схема для статусов узлов
*/
export const nodeStatusColorScheme: NodeStatusScheme = {
  notAvailable: 'lightgray',
  bottomErrorBoundary: '#f800ff',
  bottomDangerBoundary: '#33acff',
  bottomWarningBoundary: '#00ffff',
  normal: '#66ff00',
  topWarningBoundary: '#fff00f',
  topDangerBoundary: '#ff8000',
  topErrorBoundary: '#ff3131',
};

/*
  Наименования статусов узлов
*/
export const nodeStatusTitles: NodeStatusScheme = {
  notAvailable: 'Неизвестно',
  bottomErrorBoundary: 'Значение ниже порога ошибки',
  bottomDangerBoundary: 'Значение ниже порога опасности',
  bottomWarningBoundary: 'Значение ниже порога предупреждения',
  normal: 'Нормальное значение',
  topWarningBoundary: 'Значение выше порога предупреждения',
  topDangerBoundary: 'Значение выше порога опасности',
  topErrorBoundary: 'Значение выше порога ошибки',
};
